import React from 'react'
import Filters from './filter'
import { StaticQuery, graphql, Link } from "gatsby"
import styled from 'styled-components'
import Layout from './layout'
import SEO from './seo'
import { formatter, md, colors, sans } from '../common'

export default ({ filter, designer }) => {
  let count = 0
  return(
    <Layout>
    <SEO title={filter || designer} />
    <StaticQuery
      query={graphql`
        query StaticQuery {
            postgres {
              allProducts(condition: {isConsigned: false}, orderBy: SKU_ASC) {
                edges {
                  node {
                    description
                    designer
                    image
                    sku
                    title
                    type
                    price
                    isConsigned
                  }
                }
              }
            }
          }
      `}
      render={data => (
          <div css={`display:flex;${md}{flex-direction:column;}`}>
          <Filters />
            <Section>
              {data.postgres.allProducts.edges.map((p, index) => {
                const item = p.node
                const showType = item.type.includes(filter) || false
                const showDesigner = item.designer.includes(designer) || false
                const show = (filter === undefined) ? showDesigner : showType

                if ( showType || showDesigner ) {
                  count++
                }

                return  <ProductCard key={index} style={{ display: show ? 'flex' : 'none'}} >
                        <Link to={`/products/${item.sku}`} css={`height:100%;display:flex;flex-direction: column;`}>
                        <ImageWrap>
                          <img src={item.image} alt={item.title} onError={(e)=>{e.target.onerror = null; e.target.src="https://s3.us-east-2.amazonaws.com/kings-jewelers/medis/gem-placeholder.jpg"}} />
                        </ImageWrap>
                          <div>
                            <h2>{item.title}</h2>
                            <Price>{item.designer} | {formatter.format(item.price)}</Price>
                          </div>
                        </Link>
                      </ProductCard>
              })}

              <NoItems style={{ display: ( count <= 0 ) ? 'block' : 'none'}} >
                <p>We do not have any products matching those filters online at this time.</p>
                <img src='https://s3.us-east-2.amazonaws.com/kings-jewelers/medis/gem-placeholder.jpg' alt="placeholder illustration for no products to show"/>
              </NoItems>

            </Section>
          </div>
      )}
    />
  </Layout>)
}

const ProductCard = styled.div`
  width: 30%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px;
  max-height: 600px;

  img {
    width: 100%;
    max-height: 500px;
    margin: auto;
  }

  ${md} {
    width: 100%
  }

  h2 {
    color: ${colors.brownLight};
    text-transform: uppercase;
    font-size: 20px;
    margin: 3px 0;
  }
`

const ImageWrap = styled.div`
  max-height: 500px;
  margin: auto;
`

const Price = styled.p`
  color: dimgrey;
`

const Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  width: calc(100vw - 220px);

  p {
    ${sans};
    margin: 0;
  }

  ${md} {
    width: 100%;
    padding: 0;
  }
`

const NoItems = styled.div`
  text-align: center;

  img {
    max-width: 300px;
  }
`
